import { render, staticRenderFns } from "./NotificationCardForComment.vue?vue&type=template&id=1044426b&scoped=true&"
import script from "./NotificationCardForComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForComment.vue?vue&type=style&index=0&id=1044426b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044426b",
  null
  
)

export default component.exports